
// redirect helper for react router

function redirect({ from, to }) {
    return {
        redirect: true, // mark this route as a redirect for tests
        path: from,
        onEnter(nextState, replace) {
            replace({
                pathname: to,
                query: nextState.location.query,
            })
        },
    }
}

module.exports = redirect
